// This file contains mappings between Exodus legacy names and new values.
const EXODUS_ASSET_NAME_TO_CHAIN_DISPLAY_NAME = {
    avalanchec: 'Avalanche',
    bsc: 'Binance Smart Chain',
    ethereumarbone: 'Arbitrum',
    ethereumarbonesepolia: 'Arbitrum Sepolia',
    ethereumholesky: 'Ethereum Holesky',
    matic: 'Polygon',
};
const EXODUS_ASSET_NAME_TO_CHAIN_SHORT_DISPLAY_NAME = {
    bitcoinregtest: 'Regtest',
    bitcointestnet: 'Testnet',
    bsc: 'BSC',
    ethereumarbonesepolia: 'Sepolia',
    ethereumholesky: 'Holesky',
    evm0xaa36a7: 'Sepolia',
    mantlesepolia: 'Sepolia',
    solanadevnet: 'Devnet',
    solanatestnet: 'Testnet',
};
// This could differ a little bit from the native token symbol (e.g. BNB vs. BSC).
const EXODUS_ASSET_NAME_TO_CHAIN_SYMBOL = {
    bitcoinregtest: 'BTC',
    bitcointestnet: 'BTC',
    ethereumarbonesepolia: 'ARB',
    ethereumholesky: 'ETH',
    mantlesepolia: 'MNT',
    matic: 'POL',
    solanadevnet: 'SOL',
    solanatestnet: 'SOL',
};
export function getChainDisplayName(asset) {
    const baseAsset = asset.baseAsset || asset;
    return (EXODUS_ASSET_NAME_TO_CHAIN_DISPLAY_NAME[baseAsset.name] ||
        baseAsset.displayNetworkName ||
        baseAsset.displayName);
}
export function getChainShortDisplayName(asset) {
    const baseAsset = asset.baseAsset || asset;
    return (EXODUS_ASSET_NAME_TO_CHAIN_SHORT_DISPLAY_NAME[baseAsset.name] ||
        getChainDisplayName(asset));
}
export function getChainSymbol(asset) {
    return (EXODUS_ASSET_NAME_TO_CHAIN_SYMBOL[asset.name] ||
        asset.displayNetworkTicker ||
        asset.displayTicker);
}
